var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"footer-copyright"},[_vm._v("\n                LN Repuestos © Todos los derechos reservados "+_vm._s(new Date().getFullYear())+"\n            ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }